/**
 * CarList Organism Component
 * Displays a grid of car cards with loading and empty states
 */

'use client'

import { CarCard } from '@/components/molecules'
import { Empty } from '@/components/ui/empty'
import { Spinner } from '@/components/ui/spinner'
import { cn } from '@/lib/utils'
import type { Car } from '@/types'

interface CarListProps {
	cars: Car[]
	isLoading?: boolean
	onCarSelect?: (car: Car) => void
	className?: string
}

export function CarList({
	cars,
	isLoading = false,
	onCarSelect,
	className,
}: CarListProps) {
	if (isLoading) {
		return (
			<div className='flex justify-center items-center py-12'>
				<Spinner className='w-8 h-8' />
			</div>
		)
	}

	if (cars.length === 0) {
		return (
			<Empty className='py-12'>
				<div className='text-center'>
					<h3 className='text-lg font-semibold mb-2'>
						No se encontraron carros
					</h3>
					<p className='text-gray-600'>
						Intenta ajustar tus filtros de búsqueda
					</p>
				</div>
			</Empty>
		)
	}

	return (
		<div
			className={cn(
				'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6',
				className
			)}
		>
			{cars.map(car => (
				<CarCard
					key={car.id}
					car={car}
					onSelect={onCarSelect}
				/>
			))}
		</div>
	)
}
